// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* SystemLogs page styles */
`, "",{"version":3,"sources":["webpack://./src/pages/System/SystemLogs/SystemLogs.css"],"names":[],"mappings":"AAAA,2BAA2B","sourcesContent":["/* SystemLogs page styles */\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
